import { HTMLAttributes } from 'react';
import classNames from 'classnames';
import { AvatarIcon } from '@components/avatar/AvatarIcon';
import { IconName } from '@components/icon';
import './AvatarBadge.scss';

export type AvatarBadgeSize = 'large' | 'medium' | 'small' | 'xs';

export interface AvatarBadgeProps extends HTMLAttributes<HTMLDivElement> {
  iconName: IconName;
  size?: AvatarBadgeSize;
  className?: string;
}

export const AvatarBadge: React.FC<AvatarBadgeProps> = ({
  iconName,
  size = 'medium',
  className,
  ...rest
}) => (
  <div
    {...rest}
    className={classNames('vds-avatar-badge', size && `vds-avatar-badge--${size}`, className)}
    aria-hidden="true">
    <AvatarIcon className="vds-avatar-badge__icon" name={iconName} />
  </div>
);
